$(function() {
  check_live_data = function(){
    var event_id = $('#event-wrapper').attr('event-id');
    $.ajax({
      url: "/events/" + event_id   + "/get_current_heat_status",
      success: function(res) {
        console.log("current heat :", res.current);
        // console.log($('#current-heat').find('row'))
        // console.log($('#current-heat').find('.row').attr('gate-total'))
        // console.log('hmmm')
        if ( $('#current-heat').attr('heat-pointer') != res.current ){
          location.reload()
        }
        if ( $('#current-heat').find('.row').attr('gate-total') != '10' ){
          location.reload()
        }
        // $.ajax({
        //   url: "/events/" + event_id   + "/live.js?current=true",
        //   // type: "post",
        //   // data: { current_heat: true },
        //   success: function(res) {
        //     console.log('okidoki')
        //   }
        // });
      }
    });
  }
  var t=setInterval(check_live_data,2000);
});
